export default [
  {
    name: 'login',
    method: 'POST_FORM', // 此类型为自定义提交类型，其实是post form类型
    // path: '/vue/account/account-login',
    path: '/vue/login',
    desc: '登录接口'
  },
  {
    name: 'logout',
    method: 'POST',
    path: '/logout',
    desc: '退出接口'
  },
  {
    name: 'getUserInfo',
    method: 'GET',
    path: '/vue/account/principal-get'// ?username=fanqz
  },
  {
    name: 'getUser',
    method: 'GET',
    path: '/vue/account/account-get'
  },
  {
    name: 'findById',
    method: 'GET',
    path: '/vue/account/account-find-by-id'
  },
  {
    name: 'getUserPage',
    method: 'POST',
    path: '/vue/account/account-page'
  },
  {
    name: 'getUserList',
    method: 'POST',
    path: '/vue/account/account-list'
  },
  {
    name: 'getPageWithRole',
    method: 'POST',
    path: '/vue/account/account-page-with-role'
  },
  {
    name: 'addUser',
    method: 'POST',
    path: '/vue/account/account-save'
  },
  {
    name: 'deleteUser',
    method: 'POST',
    path: '/vue/account/account-delete'
  },
  {
    name: 'updateRole',
    method: 'POST',
    path: '/vue/account/account-updateRole'
  },
  {
    name: 'updateRoleList',
    method: 'POST',
    path: '/vue/account/account-update-role-list'
  },
  {
    name: 'getUserAuth',
    method: 'GET',
    path: '/vue/education/userauth-get'
  },
  {
    name: 'getUserAuthPage',
    method: 'POST',
    path: '/vue/education/userauth-page'
  },
  {
    name: 'saveUserAuth',
    method: 'POST',
    path: '/vue/education/userauth-save'
  },
  {
    name: 'auditUserAuth',
    method: 'POST',
    path: '/vue/education/userauth-audit'
  },
  {
    name: 'deleteUserAuth',
    method: 'POST',
    path: '/vue/education/userauth-delete'
  },
  {
    name: 'accountAuto',
    method: 'GET',
    path: '/vue/account/account-auto'// ?username=fanqz
  },
  {
    name: 'updatePasswordByToken',
    method: 'POST',
    path: '/vue/account/update-password-by-token'
  },
  {
    name: 'resetPassword',
    method: 'GET',
    path: '/vue/account/reset-password'
  }
];
